import { Injectable } from '@angular/core';
import { IIcon, IconName } from '../_shared/models/icon.model';

@Injectable({
    providedIn: 'root',
})
export class IconService {
    private _icons = new Map<IconName, string>();

    public addIcons(icons: IIcon[][]) {
        icons.forEach((x) => {
            x.forEach((y) => {
                this._icons.set(y.name, y.data);
            });
        });
    }

    public getIcon(iconName?: IconName): string {
        if (!iconName) {
            throw new Error(`An icon name must be specified`);
        }

        const icon = this._icons.get(iconName);

        if (!icon) {
            throw new Error(`Invalid icon name: ${iconName}`);
        }

        return icon;
    }

    public isFlag = (iconName: IconName): boolean => iconName.substring(0, 5) === 'flag_';

    public isPictogram = (iconName: IconName): boolean =>
        iconName.substring(iconName.length - 10, iconName.length) === '_pictogram';
}
